"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard").default;
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipNavLink = exports.SkipNavContent = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
// Original Code Source https://github.com/reach/reach-ui
// Moving here to resolve unmet peer dependency issues related to React 18
// If resolved, should consider reverting to @reach/skip-nav
// See: https://github.com/reach/reach-ui/issues/916

////////////////////////////////////////////////////////////////////////////////

// Original Code Source @reach/polymorphic
// https://github.com/reach/reach-ui/blob/dev/packages/polymorphic/src/reach-polymorphic.ts

////////////////////////////////////////////////////////////////////////////////

// Original Code Source @reach/skip-nav
// https://github.com/reach/reach-ui/blob/dev/packages/skip-nav/src/reach-skip-nav.tsx

// The user may want to provide their own ID (maybe there are multiple nav
// menus on a page a use might want to skip at various points in tabbing?).
const defaultId = 'reach-skip-nav';

/**
 * SkipNavLink
 *
 * Renders a link that remains hidden until focused to skip to the main content.
 *
 * @see Docs https://reach.tech/skip-nav#skipnavlink
 */
const SkipNavLink = exports.SkipNavLink = /*#__PURE__*/React.forwardRef(function SkipNavLink(_ref, forwardedRef) {
  let {
    as: Comp = 'a',
    children = 'Skip to content',
    contentId,
    ...props
  } = _ref;
  const id = contentId || defaultId;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Comp, {
    ...props,
    ref: forwardedRef,
    href: `#${id}`
    // TODO: Remove in 1.0 (kept for back compat)
    ,
    "data-reach-skip-link": "",
    "data-reach-skip-nav-link": "",
    children: children
  });
});

/**
 * @see Docs https://reach.tech/skip-nav#skipnavlink-props
 */

SkipNavLink.displayName = 'SkipNavLink';

////////////////////////////////////////////////////////////////////////////////

/**
 * SkipNavContent
 *
 * Renders a div as the target for the link.
 *
 * @see Docs https://reach.tech/skip-nav#skipnavcontent
 */
const SkipNavContent = exports.SkipNavContent = /*#__PURE__*/React.forwardRef(function SkipNavContent(_ref2, forwardedRef) {
  let {
    as: Comp = 'div',
    id: idProp,
    ...props
  } = _ref2;
  const id = idProp || defaultId;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Comp, {
    ...props,
    ref: forwardedRef,
    id: id,
    "data-reach-skip-nav-content": ""
  });
});

/**
 * @see Docs https://reach.tech/skip-nav#skipnavcontent-props
 */

SkipNavContent.displayName = 'SkipNavContent';

////////////////////////////////////////////////////////////////////////////////
// Exports